import { Flex, Table } from "@mantine/core";
import { useTranslation } from "react-i18next";

export default function PupillometryTables(props: any) {
  const { leftResults, rightResults } = props;
  const { t } = useTranslation();

  const formatValue = (value, unit) => {
    if (typeof value !== "number" || !Number.isFinite(value)) {
      return "—";
    }

    return `${Math.abs(value).toFixed(2)} ${unit}`;
  };

  const table = (results, eye) => {
    return (
      <Table variant="vertical" layout="fixed" withTableBorder>
        <Table.Tbody>
          <Table.Tr key={eye}>
            <Table.Th w={160} colSpan={2}>
              {t(eye)}
            </Table.Th>
          </Table.Tr>
          {results.map((result, index) => {
            return (
              <Table.Tr key={index}>
                <Table.Th w={160}>{String(result.label).toUpperCase()}</Table.Th>
                <Table.Td>{formatValue(result.value, result.unit)}</Table.Td>
              </Table.Tr>
            );
          })}
        </Table.Tbody>
      </Table>
    );
  };

  return (
    <Flex justify={"space-between"} align={"center"} gap={"md"} my={"md"}>
      {table(leftResults, "leftEye")}
      {table(rightResults, "rightEye")}
    </Flex>
  );
}
